// The server stores placement rows (street address + terminal count) because the processor's Terminals sheet carries an
// address on every terminal row. The wizard keeps exactly ONE row per location, mirroring the location's own address:
// terminals at a different street address are a different location (Todd, 2026-09-27).
export const addressOf = l => ({ street: l.street || '', city: l.city || '', state: l.state || '', zip: l.zip || '' });
export function withPrimaryPlacement(location) {
  const first = (location.placements || [])[0];
  return { ...location, placements: [first ? { ...first, ...addressOf(location) } : { ...addressOf(location), quantity: 1 }] };
}
export function setPrimaryQuantity(location, quantity) {
  const l = withPrimaryPlacement(location);
  return { ...l, placements: [{ ...l.placements[0], quantity }] };
}
export const clampQuantity = v => Math.max(0, Math.min(50, parseInt(v || '0', 10) || 0));
